/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {safetyNetValidateAttestation} from '../api'

export const useMutationSafetyNetValidateAttestation = createReactQueryMutationHook('safetyNetValidateAttestation', safetyNetValidateAttestation)
